import { useMemo, useState } from 'react';
import type { tRetentionPauseTerms } from '../../../../SubscriptionManager.types';

export default function usePauseOffer(terms: tRetentionPauseTerms) {
  const [selectedMonths, setSelectedMonths] = useState<1 | 2 | 3>(
    terms.monthOptions[0].months,
  );

  const selectedOption = useMemo(
    () =>
      terms.monthOptions.find((option) => option.months === selectedMonths) ??
      terms.monthOptions[0],
    [selectedMonths, terms.monthOptions],
  );

  return { selectedMonths, selectedOption, setSelectedMonths };
}
